import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask3900To3999Service {

  constructor() { }
}
